function randomLat() {
  var x = (Math.floor(10.79513620160893 * 11) + Math.random()) / 11;
  return x;
}
function randomLng() {
  var x = (Math.floor(106.6757337594251 * 11) + Math.random()) / 11;
  return x;
}

function randomPrice() {
  var x = Math.floor(Math.random() * 1000);
  return x + "k";
}

function randomRate() {
  var x = Math.floor(Math.random() * 50) / 10;
  if (x < 3) {
    x = x + 2;
  }
  return x;
}

function randomPic() {
  var x = Math.floor(Math.random() * 1000);
  if (x < 1) {
    x = x + 1;
  }
  return x;
}

const roomDataReducer = (state = RoomData, action) => {
  switch (action.type) {
    case "ADD_ADDRESS_LAT_LNG": {
      const newList = RoomData.roomList;

      const lat = action.payload[1].lat;
      const lng = action.payload[1].lng;
      const newRoomList = newList.map((item) => {
        item.cityName = action.payload[0];
        item.title = "Welcome to my home";
        item.lat = (Math.floor(lat * 15) + Math.random()) / 15;
        item.lng = (Math.floor(lng * 15) + Math.random()) / 15;
        return item;
      });

      const newChosenPlace = RoomData.chosenPlace;
      newChosenPlace.cityName = action.payload[0];
      newChosenPlace.lat = action.payload[1].lat;
      newChosenPlace.lng = action.payload[1].lng;
      return { chosenPlace: newChosenPlace, roomList: newRoomList };
    }

    case "ADD_POPUP_LAT_LNG": {
      const newChosenPlace = RoomData.chosenPlace;
      newChosenPlace.lat = action.payload.lat;
      newChosenPlace.lng = action.payload.lng;
      return { ...state, chosenPlace: newChosenPlace };
    }

    default:
      return state;
  }
};
export default roomDataReducer;

const RoomData = {
  chosenPlace: {
    cityName: "Hồ Chí Minh, Việt Nam",
    lat: 10.79513620160893,
    lng: 106.6757337594251,
  },
  roomList: [
    {
      code: "0",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "1",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "2",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "3",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "4",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "5",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "6",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "7",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "8",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "9",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "10",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "11",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "12",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "13",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "14",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "15",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "16",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "17",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "18",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "19",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "20",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "21",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "22",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "23",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "24",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "25",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "26",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "27",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "28",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "29",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "30",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "31",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "32",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "33",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "34",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "35",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "36",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "37",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "38",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "39",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "40",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "41",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "42",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "43",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "44",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "45",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "46",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "47",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "48",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "49",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "50",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
    {
      code: "51",
      mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
      subPic1:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic2:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic3:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      subPic4:
        "https://i.pinimg.com/564x/be/cd/8c/becd8c8229f435a5d424688065168280.jpg",
      title: "Welcome to Ho Chi Minh, Việt Nam",
      maxGuestNo: "3",
      roomNo: "1",
      bedNo: "2",
      rate: randomRate(),
      rateNo: "4.6",
      price: randomPrice(),
      lat: randomLat(),
      lng: randomLng(),
      cityName: "Hồ Chí Minh, Việt Nam",
    },
  ],
};
